import axios from "axios";
import { FlightItineraryRequest, FlightItineraryResponse } from "redmond";
import { config } from "../../../api/config";
import { apiVersionPrefix } from "../../../api/v0/paths";

export type { FlightItineraryRequest, FlightItineraryResponse };

const flightItineraryApiPath = `${apiVersionPrefix}/itinerary/flight`;

// Flight API wraps response in { value: FlightItineraryResponse }
interface FlightApiResponse {
  value: FlightItineraryResponse;
}

export const fetchFlightItineraries = async (
  req: FlightItineraryRequest
): Promise<FlightItineraryResponse> => {
  const res = await axios.put<FlightApiResponse>(flightItineraryApiPath, req, {
    baseURL: config.baseURL,
  });
  return res.data.value;
};
